import { SETTINGS } from './settings.config';

export const ROUTES = {
  // General
  ROOT: '/',
  HOME: '/',
  FIRST_SCREEN: '/first-screen',
  ENROLL_NOW: '/enroll-now',

  UNITS_OF_MEASURE: SETTINGS.UNITS_OF_MEASURE.route,
  UPLOAD_HISTORY: SETTINGS.UPLOAD_HISTORY.route,

  // Control Documents
  CONTROL_DOCUMENTS: SETTINGS.CONTROL_DOCUMENTS.route,

  // Organizations
  ORGANIZATIONS: {
    LIST: SETTINGS.ORGANIZATIONS.route,
    CREATE: '/organizations/create',
    EDIT: '/organizations/:id/edit',
  },

  // Users
  USERS: {
    LIST: SETTINGS.USERS.route,
    CREATE: '/users/create',
    VIEW: '/users/:id/view',
    EDIT: '/users/:id/edit',
  },

  // Roles
  ROLES: {
    LIST: SETTINGS.ROLES.route,
    VIEW: '/roles/:id/view',
    EDIT: '/roles/:id/edit',
    DUPLICATE: '/roles/:id/duplicate',
  },

  // Products
  PRODUCTS: {
    LIST: SETTINGS.PRODUCTS.route,
    CREATE: '/products/create',
    VIEW: '/product/:id/view',
    EDIT: '/product/:id/edit',
  },

  // Processes & Traceability
  PROCESSES: {
    MAPS: {
      LIST: SETTINGS.PROCESSES_MAP.route,
      CREATE: '/process-maps/create',
      ARCHIVED: '/process-maps/archived',
      MAP: {
        VIEW: '/process-maps/map/:id/view',
        EDIT: '/process-maps/map/:id/edit',
        CONFIG: '/process-maps/map/:id/configure/:list?',
        BLOCK: {
          EDIT: '/process-maps/map/:id/process/:processId/edit/:tab?',
          VIEW: '/process-maps/map/:id/process/:processId/view/:tab?',
        },
      },
    },
  },

  // Error Upload Details

  ERROR_DETAILS: {
    LIST: '/error-details/:id/details',
  },

  // Data Sources
  DATA_SOURCES: {
    LIST: SETTINGS.DATA_SOURCES.route,
    EDIT: '/data-sources/:id/edit',
  },

  // Data & Reports
  DATA: {
    APPROVE: '/data-sharing/:companyId/target-company/:targetCompanyId/approve',
    TABLES: SETTINGS.DATA_TABLES.route,
    CAPTURE_FORMS: {
      LIST: SETTINGS.DATA_CAPTURE_FORMS.route,
      EDIT: '/data-capture/:id/edit/:traceability?/:processFlow?',
      VIEW: '/data-capture/:id/view',
    },
  },

  // Administration & Reports
  ADMIN: '/admin',
  REPORTS: SETTINGS.REPORTS.route,
  DASHBOARD: '/dashboard',
};
